<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="loseDialog"
    :close-on-click-modal="false"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="100px"
      class="form"
    >
      <el-row :gutter="12">
        <!-- :span="12" -->
        <el-col>
          <el-form-item label="菜单类型：" required>
            <el-radio-group v-model="curdForm.menuType">
              <el-radio
                size="medium"
                :label="i"
                v-for="(item, i) in menuTypeList"
                :key="i"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="菜单名称：" prop="menuName">
            <el-input
              v-model="curdForm.menuName"
              placeholder="请填写菜单名称"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            v-if="curdForm.menuType !== 0"
            label="上级菜单："
            prop="parentMenuName"
          >
            <popup-tree-input
              :data="curdForm.menuType == 1 ? menuTreeList : menuTreeAllList"
              :props="props"
              :prop="curdForm.parentMenuName"
              :currentChangeHandle="getMenuID"
              placeholder="请选择上级菜单"
              :show-checkbox="true"
              ref="numberInput"
            ></popup-tree-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            v-if="curdForm.menuType == 1"
            label="菜单url："
            prop="menuUrl"
          >
            <el-input
              v-model="curdForm.menuUrl"
              placeholder="请填写菜单url"
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            v-if="curdForm.menuType == 2"
            label="按钮url："
            prop="menuUrl"
          >
            <el-input
              v-model="curdForm.menuUrl"
              placeholder="请填写按钮url"
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            v-if="!!curdForm.menuUrl"
            label="是否缓存："
            prop="keepAlive"
          >
            <el-radio-group v-model="curdForm.keepAlive">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            v-if="curdForm.menuType !== 0"
            label="授权标识："
            prop="permissions"
          >
            <el-input
              v-model="curdForm.menuPermissions"
              placeholder="请输入授权标识，多个标识用/分隔，例如：user:list,user:update"
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            v-if="curdForm.menuType === 0"
            label="菜单图标："
            prop="menuIcon"
          >
            <el-popover
              placement="bottom"
              width="350"
              trigger="click"
              popper-class="add-el-popover"
            >
              <div slot="reference" class="menu-icon-view">
                <i :class="[curdForm.menuIcon]"></i>
                <span>点击选择菜单图标</span>
              </div>
              <div class="icon-list">
                <i
                  v-for="item in iconClassList"
                  :key="item"
                  :class="item"
                  @click="selectIcon(item)"
                />
              </div>
            </el-popover>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="排序：" prop="order">
            <el-input-number
              v-model="curdForm.order"
              :min="0"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item 
          label="是否展示：" required
          v-if="curdForm.menuType === 0 || curdForm.menuType === 1"
          prop="isShow"
          >
            <el-radio-group v-model="curdForm.isShow">
              <el-radio
                size="medium"
                :label="i"
                v-for="(item, i) in isShowList"
                :key="i"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom('curdForm')" btntype title="取消"></butn>
      <butn
        btntype="primary"
        @click.native="createData(parentId)"
        title="确定"
      ></butn>
    </div>
  </el-dialog>
</template>

<script>
import { MENU_TYPE, ICON_CLASS_LIST, MENU_STATUS } from "@/utils/constants";
import butn from "@/components/button/index";
import Bus from "./Bus";
import rulesFactory from "@/utils/rules";
import PopupTreeInput from "@/components/PopupTreeInput/noLazyTree";
import { listInsert, listUpdate, menuTree } from "@/api/menu";
function mergeLeaf(item) {
  if (!item.son) return item;
  return { ...item.itself, children: item.son.map(mergeLeaf) };
}
export default {
  components: { butn, PopupTreeInput },
  props: {
    menuTreeAllList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      Bus,
      menuTreeList: [], //目录 菜单
      menuTypeList: MENU_TYPE,
      isShowList: MENU_STATUS,
      iconClassList: ICON_CLASS_LIST,
      menuType: 0,
      isShow: 1,
      rules: {
        menuName: [
          rulesFactory.required("请输入菜单名称"),
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        menuType: [rulesFactory.required("请填写菜单类型")],
        parentMenuName: [rulesFactory.required("上级菜单为空")],
      },
      curdTitle: "",
      CUFlag: false,
      Dflag: false,
      curdForm: {},
      props: {
        //树形
        label: "menuName",
        children: "children",
      },
      nodeKey: "apiId",
      defaultCheckedKeys: [],
      command: function () {},
      parentId: "",
    };
  },
  created() {
    var _this = this;
    Bus.$on("ReceiveMessage", function (item) {
      _this.$nextTick(() => {
        _this.curdTitle = item == "" ? "新增菜单" : "修改菜单";
        _this.command = item == "" ? listInsert : listUpdate;
        _this.CUFlag = true;
        _this.parentId = "";
        _this.curdForm = item || {
          menuType: 0,
          order: 0,
          parentId: "",
          parentMenuName: "",
          isShow: 1,
        };
        if (item === "123") {
          _this.CUFlag = false;
          _this.initMenuL();
        }
      });
    });
  },
  mounted() {
    this.initMenuL();
  },
  computed: {
    // menuTreeList() {
    //   return this.apiname.map(mergeLeaf);
    // }
  },
  methods: {
    selectIcon(item) {
      this.$set(this.curdForm, "menuIcon", item);
    },
    initMenuL() {
      menuTree().then((data) => {
        this.menuTreeList = data.data.map(mergeLeaf);
      });
    },
    createData(parentId) {
      this.$refs.curdForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // console.log(this.$refs.numberInput.prop, parentId, "prop");
          if (this.curdForm.menuType > 0) {
            this.curdForm.parentId = this.curdForm.parentId
              ? this.curdForm.parentId
              : parentId;
          }
          const params = Object.assign({}, this.curdForm);
          this.command(params).then((res) => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("click");
              this.initMenuL();
              this.CUFlag = false;
            }
          });
        }
      });
    },
    getMenuID(data) {
      if (this.curdForm.menuName == data.menuName) {
        this.$message.error("上级菜单名称与菜单名称重复");
        return;
      }
      this.curdForm.parentId = data.uuid;
      this.curdForm.parentName = data.menuName;
      this.curdForm.parentMenuName = data.menuName;
    },
    closeFrom(curdForm) {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs[curdForm].resetFields();
    },
    loseDialog() {
      // 点击取消 数据重置
      this.CUFlag = false;
      this.$refs["curdForm"].resetFields();
    },
  },
  beforeDestroy() {
    Bus.$off("ReceiveMessage");
  },
};
</script>

<style lang="scss" scoped>
.menu-icon-view {
  background: #222e4c;
  padding: 0 20px;
  cursor: pointer;
  i {
    vertical-align: middle;
  }
}
.icon-list {
  background: #222e4c;
  padding: 10px;
  i {
    cursor: pointer;
    margin-left: 5px;
  }
}
</style>
